import React from 'react';
import Doughnut from './Doughnut';
import { backgroundColors, varCoolgray200 } from '../chartColors';
import { StatStructure } from '../ChartLegend';

export interface DonutChartProps {
  id: string;
  data?: StatStructure[];
  label: string;
  value: string;
  colors: string[];
  children?: React.ReactNode;
}

export const DonutChart: React.FC<DonutChartProps> = ({ id, data, label, value, colors, children }) => {
  let disableTooltips = false;
  const labels = data?.map((r: any) => r[label]) || [];
  const values = data?.map((r: any) => r[value]) || [];

  const chartData = {
    labels,
    datasets: [
      {
        label: 'responses',
        data: values,
        backgroundColor: backgroundColors(colors, values),
        borderWidth: 0,
      },
    ],
  };

  // setup empty ring if all values are 0
  chartData.datasets.forEach(dataset => {
    if (dataset.data.every((el: number) => el === 0)) {
      dataset.backgroundColor.push(varCoolgray200);
      dataset.data.push(1);
      disableTooltips = true;
    }
  });

  return (
    <Doughnut id={id} data={chartData} disableTooltips={disableTooltips}>
      {children}
    </Doughnut>
  );
};
